import request from "@/util/request.js";
export const areaBranch = token => {
  return request.post("api/sansint-energy/electricSence/areaBranch", {
    token
  });
};
// 获取预警通知
export const warnLogMessage = () => {
  return request.get("/api/sansint-energy/warnLog/saveAndSendMessage");
};
